const UploadErrorIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M13 17h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor" />
  </svg>
);

export default UploadErrorIcon;
